import { render, staticRenderFns } from "./FormDokterEdit.vue?vue&type=template&id=d0f4f55e&"
import script from "./FormDokterEdit.vue?vue&type=script&lang=js&"
export * from "./FormDokterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports